import { useEffect, useState } from 'react';
import {
  type BrandProfileKey,
  DEFAULT_BRAND_BY_PROFILE,
  getBrandColor,
  getBrandGradient,
  resolveSidebarTextColor,
} from './profileBrandColors';

/**
 * Marca do perfil (accent + gradiente de sidebar), reativa a `ac-theme-updated`.
 */
export function useProfileBrandColor(key: BrandProfileKey) {
  const [brandColor, setBrandColor] = useState(() => getBrandColor(key));
  const [brandGradient, setBrandGradient] = useState(() => getBrandGradient(key));

  useEffect(() => {
    const sync = () => {
      setBrandColor(getBrandColor(key));
      setBrandGradient(getBrandGradient(key));
    };
    sync();
    window.addEventListener('ac-theme-updated', sync);
    return () => window.removeEventListener('ac-theme-updated', sync);
  }, [key]);

  return {
    brandColor,
    brandGradient,
    sidebarTextColor: resolveSidebarTextColor(brandColor, brandGradient),
    defaultColor: DEFAULT_BRAND_BY_PROFILE[key],
  };
}
